import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'
import {clearLocalStorageExcept} from 'thesis-and-dissertations/helpers/helper'
import TableData from './TableData'

const api = new Api()

const ChangeStatusPage: FC = () => {
  const [loading, setLoading] = useState(false)
  const [formValue, setFormValue] = useState({})
  const [errors, setErrors] = useState<any>({})
  const [refreshTable, setRefreshTable] = useState<any>(false)

  const save = () => {
    setLoading(true)
    api
      .updateStatusAssessment(formValue)
      .then((response: any) => {
        const {data} = response.data

        if (data?.errors) {
          setErrors({nomor_pendaftaran: data?.errors})
        }

        setRefreshTable(true)
        setLoading(false)
        toast.success(data?.message ?? data?.meta?.message ?? 'Berhasil simpan data')
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        toast.error(data?.meta?.message ?? data?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
        setErrors(data?.meta?.error ?? data?.errors)
      })
  }

  const handleInput = (name: any, value: any) => {
    setFormValue({...formValue, [name]: value})
    setErrors({})
  }

  return (
    <>
      <div className='card'>
        <div className='p-7 border-bottom'>
          <p className='fs-4 fw-bold'>Ubah Status Peserta</p>
        </div>

        <div className='px-8 pt-8'>
          <div>
            <textarea
              className={`form-control ${errors?.nomor_pendaftaran && 'border-danger'}`}
              placeholder='Masukkan daftar kode registrasi peserta, cukup copy-paste dari excel'
              onChange={(e: any) => {
                const array = e?.target?.value.split(/\r?\n/)
                handleInput('nomor_pendaftaran', array)
              }}
            ></textarea>
            {errors?.nomor_pendaftaran && (
              <p className='text-danger mb-3'>{errors?.nomor_pendaftaran}</p>
            )}
          </div>
          <div className='mt-5'>
            <p>Jenis Penilaian</p>
            <select
              className={`form-control mt-1 ${errors?.jenis_penilaian && 'border-danger'}`}
              onChange={(e: any) => handleInput('jenis_penilaian', e.target?.value)}
            >
              <option value=''>--Pilih Jenis Penilaian--</option>
              <option value='verifikator'>Verifikator</option>
              <option value='proposal'>Proposal</option>
              <option value='wawancara'>Wawancara</option>
              <option value='pendaftaran'>Hasil Seleksi Akhir</option>
            </select>

            {errors?.jenis_penilaian && (
              <p className='text-danger mb-3'>{errors?.jenis_penilaian}</p>
            )}
          </div>

          <div className='mt-5'>
            <p>Status Pendaftaran</p>
            <select
              className={`form-control mt-1 ${errors?.status && 'border-danger'}`}
              onChange={(e: any) => handleInput('status', e.target?.value)}
            >
              <option value=''>--Pilih Status--</option>
              <option value='Lolos'>Lulus</option>
              <option value='Tidak Lolos'>Tidak Lulus</option>
            </select>
            {errors?.status && <p className='text-danger mb-3'>{errors?.status}</p>}
          </div>

          <div className='my-10 d-grid'>
            <button className='btn btn-primary btn-sm btn-block' onClick={save} disabled={loading}>
              {loading ? 'Loading...' : 'Ubah Status'}
            </button>
          </div>
        </div>
      </div>

      <div className='card mt-10'>
        <div className='p-7 border-bottom'>
          <p className='fs-4 fw-bold'>Riwayat Ubah Status Peserta</p>
        </div>

        <div className='px-8 py-8'>
          <TableData refreshTable={refreshTable} />
        </div>
      </div>
    </>
  )
}

const ChangeStatus: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Ubah Status Peserta
      </PageTitle>
      <ChangeStatusPage />
    </>
  )
}

export default ChangeStatus
